// extracted by mini-css-extract-plugin
export default {"ModalBox":"AttachmentLoadingModal_ModalBox__6Du0G","Title":"AttachmentLoadingModal_Title__rGvdr","List":"AttachmentLoadingModal_List__tmLuE"};